<script lang="ts">
  import { Refund } from "@models/refunds/Refund"
  import { maxRefundable, RefundAvailability } from "@models/refunds/RefundAvailability"

  import { formatCentsAsUsd } from "@util/money"

  export let refundAvailability: RefundAvailability
  export let refund: Refund
  export let fees: number
</script>

<div class="flex items-center mt-2" data-testid="RefundMathBreakdown-paidAmount">
  <div class="text-gray-800">Amount Paid for Passenger (Not Including Fees)</div>
  <div class="flex-1 text-right text-lg">{formatCentsAsUsd(refundAvailability.grossAmount - fees)}</div>
</div>

{#if refund.includeFees && fees > 0}
  <div class="flex items-center mt-2" data-testid="RefundMathBreakdown-fees">
    <div class="text-gray-800">Convenience Fees:</div>
    <div class="flex-1 text-right text-lg">+ {formatCentsAsUsd(fees)}</div>
  </div>
{/if}

{#if refundAvailability.refundedAmount > 0}
  <div class="flex items-center mt-2" data-testid="RefundMathBreakdown-refundedAmount">
    <div class="text-gray-800">Refunded so far:</div>
    <div class="flex-1 text-right text-lg">- {formatCentsAsUsd(refundAvailability.refundedAmount)}</div>
  </div>
{/if}

<div class="flex items-center mt-2" data-testid="RefundMathBreakdown-maxRefundable">
  <div class="text-gray-800">Max Refundable</div>
  <div class="flex-1 text-right text-lg">
    <strong>{formatCentsAsUsd(maxRefundable(refundAvailability, refund.includeFees))}</strong>
  </div>
</div>
